import PubSub from "underpub-js";
import tippy, {
  followCursor
} from 'tippy.js';
import 'tippy.js/animations/shift-toward.css';

const attomApiKey = "a97989257d5cfd490f360a99b2f7a4e4";

var Calculator = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-Calculator',
  };

  $.extend(true, this.options, options);

};

Calculator.prototype.init = function () {

  var self = this;

  const $form = this.options.$el.find('.fui-form');
  const $formPages = $form.find(".fui-page");
  const $numberInputs = $form.find("input[data-type='number']");
  let data = {};
  // Update index to be page number -1 if no intro step is used
  const $page1 = $form.find(".fui-page[data-index='1']");
  const $page2 = $form.find(".fui-page[data-index='2']");
  const $page3 = $form.find(".fui-page[data-index='3']");
  const $page4 = $form.find(".fui-page[data-index='4']");
  const $page5 = $form.find(".fui-page[data-index='5']");

  // Page 1 inputs
  const $streetAddressInput = $form.find("[name='fields[streetAddress]']");
  const $cityInput = $form.find("[name='fields[city]']");
  const $stateInput = $form.find("[name='fields[state]']");
  const $zipCodeInput = $form.find("[name='fields[zipCode]']");
  // Page 2 inputs
  const $squareFootageInput = $form.find("[name='fields[squareFootage]']");
  const $estimatedHomeValueInput = $form.find("[name='fields[estimatedHomeValue]']");
  const $monthlyRentalIncomeInput = $form.find("[name='fields[monthlyRentalIncome]']");
  // Page 5 inputs
  const $priyaMembershipFeeInput = $form.find("[name='fields[priyaMembershipFee]']");
  // Total inputs
  const $costOfLivingReport = $form.find(".cost-of-living-report");
  const $costOfLivingReportComments = $form.find(".cost-of-living-report-comments");
  const $costOfLivingReportInput = $form.find("[name='fields[resultsCostOfLivingReport]']");

  const removeNumberFormat = number => parseFloat(number.toString().replace(/[^0-9.]/g, ''));
  const applyNumberFormat = (number, addDecimals = false) => {
    const baseNumber = addDecimals ? parseFloat(number).toFixed(2) : parseFloat(number).toString();
    return baseNumber.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
  };
  const applyCurrencyFormat = (number) => `$${applyNumberFormat(number, true)}`;

  // If intro step is used, steps match the index, if no intro step is used, add + 1 to get accurate page id
  const getCurrentPageId = () => $formPages.not(".fui-hidden").data("index");

  const getPage1Data = () => {
    const streetAddress = $streetAddressInput.val();
    const city = $cityInput.val();
    const state = $stateInput.val();
    const zipCode = $zipCodeInput.val();

    data = {
      ...data,
      details: {
        ...data.details,
        streetAddress,
        city,
        state,
        zipCode
      }
    }
  }

  const getPage2Data = () => {
    const squareFootage = removeNumberFormat($squareFootageInput.val()) || 0;
    const estimatedHomeValue = removeNumberFormat($estimatedHomeValueInput.val()) || 0;
    const monthlyRentalIncome = removeNumberFormat($monthlyRentalIncomeInput.val()) || 0;

    data = {
      ...data,
      details: {
        ...data.details,
        squareFootage,
        estimatedHomeValue,
        monthlyRentalIncome
      }
    }
  }

  const setPage2Data = () => {
    $.ajax({
      url: "https://api.gateway.attomdata.com/propertyapi/v1.0.0/avm/detail?",
      method: "get",
      data: {
        address1: data.details.streetAddress,
        address2: `${data.details.city} ${data.details.state}`
      },
      headers: {
        "Accept": "application/json",
        "apikey": attomApiKey
      },
      error: function (error) {
        console.log(error);

        if (getCurrentPageId() == 2) {
          $(`<span class="input-note">We're unable to retrieve estimated square footage data. Please input it manually.</span>`).insertBefore($squareFootageInput.closest(".fui-input-container"));
          $squareFootageInput.val("");

          $(`<span class="input-note">We're unable to retrieve estimated home value data. Please input it manually.</span>`).insertBefore($estimatedHomeValueInput.closest(".fui-input-container"));
          $estimatedHomeValueInput.val("");
        }
      },
      success: function (response, status) {
        const property = response.property[0];

        if (typeof property == "undefined") return;

        const squareFootage = property.building.size.livingsize;
        const estimatedHomeValue = property.avm.amount.value;

        if (squareFootage == 0) {
          $(`<span class="input-note">We're unable to retrieve estimated square footage data. Please input it manually.</span>`).insertBefore($squareFootageInput.closest(".fui-input-container"));
          $squareFootageInput.val("");
        } else {
          $squareFootageInput.val(applyNumberFormat(squareFootage, true));
        }

        if (estimatedHomeValue == 0) {
          $(`<span class="input-note">We're unable to retrieve estimated home value data. Please input it manually.</span>`).insertBefore($estimatedHomeValueInput.closest(".fui-input-container"));
          $estimatedHomeValueInput.val("");
        } else {
          $estimatedHomeValueInput.val(applyNumberFormat(estimatedHomeValue, true));
        }
      }
    });

    $.ajax({
      url: "https://api.gateway.attomdata.com/propertyapi/v1.0.0/valuation/rentalavm?",
      method: "get",
      data: {
        address1: data.details.streetAddress,
        address2: `${data.details.city} ${data.details.state}`
      },
      headers: {
        "Accept": "application/json",
        "apikey": attomApiKey
      },
      error: function (error) {
        console.log(error);

        if (getCurrentPageId() == 2) {
          alert("There has been an error loading rental data. We have filled the form with placeholder data for demonstration purposes.");

          $monthlyRentalIncomeInput.val(applyNumberFormat(3800, true))
        }
      },
      success: function (response, status) {
        const property = response.property[0];

        if (typeof property == "undefined") return;

        const estimatedRentalIncome = property.rentalAvm.estimatedRentalValue;

        if (estimatedRentalIncome == 0) {
          $(`<span class="input-note">We're unable to retrieve estimated rental income data. Please input it manually. If you're unsure, you can multiply your home value by 0.008.</span>`).insertBefore($monthlyRentalIncomeInput.closest(".fui-input-container"));
          $monthlyRentalIncomeInput.val("");
        } else {
          $monthlyRentalIncomeInput.val(applyNumberFormat(estimatedRentalIncome, true));
        }
      }
    });
  }

  const getPage3Data = () => {
    const priyaMembershipFee = removeNumberFormat($priyaMembershipFeeInput.val()) || 0;

    data = {
      ...data,
      priyaMembershipFee
    }
  }

  const initTooltips = () => {
    const tooltips = $("[data-tooltip]");

    tooltips.each((index, item) => {
      const $item = $(item);
      const tooltipHeading = $item.data("text");
      const tooltipText = $item.data("tooltip");

      tippy($item[0], {
        content: `
          ${tooltipHeading && tooltipHeading.length ? `<h5>${tooltipHeading}</h5>` : ""}
          <p>${tooltipText}</p>
        `,
        allowHTML: true,
        arrow: true,
        theme: 'primary',
        inertia: true,
        animation: 'shift-toward',
        duration: [500, 300],
        delay: 100,
        followCursor: "horizontal",
        plugins: [followCursor],
      });
    })
  }

  const setTotals = () => {
    const differenceTotal = parseInt(data.priyaMembershipFee) - parseInt(data.details.monthlyRentalIncome);

    const costOfLivingReportHtml = `
      <div class="results">
        <h3 class="heading">Monthly Net Expenses Today</h3>
        <div class="section">
          <div class="section__header item">
            <span class="item__text">Membership Fee</span>
            <span class="item__value">${applyCurrencyFormat(parseInt(data.priyaMembershipFee))}</span>
          </div>
        </div>
        <div class="separator"></div>
        <div class="section">
          <div class="section__header item">
            <span class="item__text">Monthly Rental Income</span>
            <span class="item__value">-${applyCurrencyFormat(parseInt(data.details.monthlyRentalIncome))}</span>
          </div>
        </div>
        <div class="separator"></div>
        <div class="section">
          <div class="section__header item item--total">
            <span class="item__text">Difference</span>
            <span class="item__value">${applyCurrencyFormat(parseInt(differenceTotal))}</span>
          </div>
        </div>
      </div>
    `;

    const costOfLivingReportResults = `
Home Value: ${applyCurrencyFormat(parseInt(data.details.estimatedHomeValue))}
Square Footage: ${data.details.squareFootage}
Rental Income: ${applyCurrencyFormat(parseInt(data.details.monthlyRentalIncome))}
-
Priya Membership Fee: ${applyCurrencyFormat(parseInt(data.priyaMembershipFee))}
Monthly Rental Income: -${applyCurrencyFormat(parseInt(data.details.monthlyRentalIncome))}
Difference: ${applyCurrencyFormat(parseInt(differenceTotal))}`;

    const costOfLivingReportCommentsHtml =
      differenceTotal >= 0 ? `
      <p>Great news, your Priya membership fee is partially covered by your monthly rental income.</p>
    ` : `
      <p>Great news, your Priya membership fee is fully covered by your monthly rental income, plus you're making an additional ${applyCurrencyFormat(differenceTotal * -1)} on top of that.</p>
    `;

    $costOfLivingReportComments.html(costOfLivingReportCommentsHtml);
    $costOfLivingReport.html(costOfLivingReportHtml);
    $costOfLivingReportInput.val(costOfLivingReportResults);
    initTooltips();
  }

  const handleData = () => {
    const currentPageId = getCurrentPageId();

    switch (currentPageId) {
      case 1:
        getPage1Data();
        setPage2Data();
        break;
      case 2:
        getPage1Data();
        getPage2Data();
        break;
      case 3:
        getPage1Data();
        getPage2Data();
        getPage3Data();
        setTotals();
        break;
      case 4:
        getPage1Data();
        getPage2Data();
        getPage3Data();
        setTotals();
        break;
      default:
        break;
    }

    console.log("Data:", data);
  }

  const handleFunctionality = () => {
    const currentPageId = getCurrentPageId();
  }

  $numberInputs.on('focus', e => {
    const $input = $(e.target);
    const inputValue = $input.val();

    if (inputValue) {
      $input.val(removeNumberFormat($input.val()));
    }
  })

  $numberInputs.on('blur', e => {
    const $input = $(e.target);
    const inputValue = $input.val();
    const addDecimals = $input.closest("[data-symbol='dollar']").length;

    if (inputValue) {
      $input.val(applyNumberFormat($input.val(), addDecimals));
    }
  })

  handleData();
  handleFunctionality();
  $form.on('onBeforeFormieSubmit', handleData);
  $form.on('onAfterFormieSubmit', handleFunctionality)
};

export default Calculator;